import { render, staticRenderFns } from "./BoxAccordion.vue?vue&type=template&id=e1b00abe&"
import script from "./BoxAccordion.vue?vue&type=script&lang=js&"
export * from "./BoxAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports